define(
    'utils/price-format',['currencyformatter', 'utils/currency-symbols'],

    function (Currency, symbols) {
        /**
         * @class PriceFormatterHelper
         */
        /**
         * @method priceFormat
         * @param {Object} value The price object
         * @param {String} property The price property to use, will default to discount
         * if available and ordinary if it's not
         * @param {Boolean} placed - Use placed price if available.
         * @return {String} The formatted price with the currency
         */
        return function (value, property, placed) {
            var priceInt;
            var priceNum;
            var origValue = value;

            if (!value || $.isEmptyObject(value)) return;

            if (placed && value.hasOwnProperty('placedPrice') && value.placedPrice !== null) {
                priceInt = value.placedPrice;
            } else if (property !== undefined && property !== 'false') {
                var propertyChain = property.split('.');
                var prop;

                $.each(propertyChain, function (i) {
                    prop = this.toString();

                    if(value[prop] !== undefined) {
                        if (i === propertyChain.length - 1) {
                            priceInt = value[prop];
                            return false;
                        }

                        value = value[prop];
                    } else {
                        return false;
                    }
                });
            } else if ((value.hasOwnProperty('discount') && value.discount !== null) || (value.hasOwnProperty('ordinary') && value.ordinary !== null)) {
                priceInt = (value.discount !== null) ? value.discount : value.ordinary;
            } else {
                return;
            }  

            if (!isNaN(parseFloat(priceInt)) && isFinite(priceInt)) priceInt = parseFloat(priceInt);

            if (priceInt !== null && priceInt !== undefined && origValue.hasOwnProperty('currency') && origValue.currency) {
                Currency.symbols = symbols;

                return Currency.format(priceInt, { currency: origValue.currency, group: ' ' });
            }
        };
    }
);

